import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../ui/utils';

type PageHeaderProps = HTMLAttributes<HTMLElement> & {
    icon?: ReactNode;
    title: string;
    description?: string;
    actions?: ReactNode;
};

function PageHeader({ icon, title, description, actions, className, ...props }: PageHeaderProps) {
    return (
        <section className={cn('nx-page-toolbar', className)} {...props}>
            <div className="nx-page-heading">
                {icon ? (
                    <div className="nx-page-icon" aria-hidden>
                        {icon}
                    </div>
                ) : null}
                <div>
                    <h1>{title}</h1>
                    {description ? <p>{description}</p> : null}
                </div>
            </div>
            {actions ? <div className="nx-page-actions">{actions}</div> : null}
        </section>
    );
}

export { PageHeader };
export type { PageHeaderProps };
